<template>
  <div>
    <OnboardingIndex
      :title="title"
      :submit_button_text="submit_button_text"
      :verification_running="verification_running"
      :show_back_button="true"
      @custom-submit="handle_enter_otp"
    >
      <template v-slot:form-content>
        <div class="mb-3">
          <p class="text-xs fw-600 text-center">Check your email for the One Time Pin</p>

          <label for="otp_number" class="text-xxs d-none">One Time Pin</label>
          <input
            type="text"
            class="form-control form-control-lg text-xs bg-light border-0 py-3"
            v-model="otp_number"
            maxlength="5"
            @keypress="validate_numbers"
            placeholder="Enter your One Time Pin here"
          />
        </div>
      </template>

      <!-- Specific to OTP -->
      <template v-slot:signup-content>
        <div class="mt-4 text-center">
          <p class="mb-1">
            Did not receive OTP?
            <a
              :class="{ 'text-muted': otp_sending, 'text-dark': !otp_sending }"
              class="text-decoration-underline cursor-pointer fw-bold"
              @click.prevent="otp_sending ? null : resend_otp()"
            >
              Click here
            </a>
            to resend.
          </p>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
